<template>
  <div>
    <div class="sayfahead">
      <h1>{{SayfaAdi}}</h1>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="4">
          <IcraListe @Kisi_id="KisiGetir($event)"></IcraListe>
        </el-col>
        <el-col :span="20">

        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
    import IcraListe from "../../../components/Pack/Icra/IcraListe";
    export default {
        components: {IcraListe},
        data() {
            return {
                SayfaAdi: 'İcralık Dosyalar',
                Kisi_id:null
            }
        },
        methods:{
            KisiGetir(event){
                this.Kisi_id=event;
                this.$router.push('/icra/dosya/' + this.Kisi_id)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Icra/dosya/liste.vue